// src/components/HomeSlider/HomeSlider.js

import React, { useRef, useEffect, useState } from "react";
import './HomeSlider.css';
import { FaVolumeMute, FaVolumeUp, FaTimes } from "react-icons/fa";
import Login from "../../Login/Login";

export default function HomeSlider() {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  const handleCloseLogin = () => {
    setShowLogin(false);
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(() => {
        console.warn("Autoplay failed.");
      });
    }
  };

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.muted = true;
      video.load();
      video.play().catch(() => {
        console.warn("Autoplay failed due to browser restrictions.");
      });

      const handleProgress = () => {
        if (video.buffered.length > 0 && video.duration > 0) {
          const bufferedEnd = video.buffered.end(video.buffered.length - 1);
          const percentLoaded = (bufferedEnd / video.duration) * 100;
          console.log(`Video loaded: ${percentLoaded.toFixed(2)}%`);
        }
      };

      const handleEnded = () => {
        console.log("Video has finished playing.");
        setShowLogin(true);
      };

      video.addEventListener('progress', handleProgress);
      video.addEventListener('ended', handleEnded);

      return () => {
        video.removeEventListener('progress', handleProgress);
        video.removeEventListener('ended', handleEnded);
      };
    }
  }, []);

  return (
    <section className="home-space">
      <div className="homearrowlide-1 arrow-style1">
        <div>
          <div className="fashion-slider">
            <video
              ref={videoRef}
              className="video-background"
              muted
              playsInline
              poster="/assets/videos/intro-video/intro-video-lg.jpg"
            >
              <source
                src="/assets/videos/intro-video/intro-video-lg.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            <div className="mute-button-container" onClick={toggleMute}>
              {isMuted ? (
                <FaVolumeMute className="mute-icon" />
              ) : (
                <FaVolumeUp className="mute-icon" />
              )}
            </div>

            <div className="custom-container">
              <div className="row">
                <div className="col-12">
                  {/* Optional content */}
                </div>
              </div>
            </div>

            {showLogin && (
              <div className="login-overlay">
                <button className="login-close-btn" onClick={handleCloseLogin}>
                  <FaTimes />
                </button>
                <div className="login-fadein">
                  <Login />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}